import clsx from 'clsx';
import { Icon } from '../../Icon';
import { AriaRole } from 'react';

export interface ScoreHealthRangeGroupProps {
  className?: string;
  tooltip?: JSX.Element;
  role?: AriaRole;
  onClick?: () => void;
  groupDisplay?: string;
}

export function ScoreHealthRangeGroup({ tooltip, className, role, onClick, groupDisplay }: ScoreHealthRangeGroupProps) {
  return (
    <button
      role={role}
      onClick={onClick}
      className={clsx(
        className,
        'py-1 max-w-full flex justify-center rounded-[10px] h-auto min-h-[26px] justify-self-center w-max relative'
      )}
    >
      <p className="text-darkMode-gray-light/70 ScoreHealthRangeGroup-label lowercase font-medium text-[13px] leading-[normal]">
        {groupDisplay}
      </p>
      {tooltip && <Icon icon="infoOutline" className="h-3 w-3 text-palette-600 absolute -top-1 -right-3" />}
    </button>
  );
}
